import React from 'react';
import { SectionBannerProps } from './types';
import { FeaturedBannerProps } from '../FeaturedBanner/types';
import { HeaderLogoProps } from '../HeaderLogo/types';
import FeaturedBanner from '../FeaturedBanner/FeaturedBanner';
import HeaderLogo from '../HeaderLogo/HeaderLogo';

/**
 * Renders a banner section that can contain banner modules (FeaturedBanner or HeaderLogo)
 * Specifically used when we need to render banner modules in one Ninetailed experience
 * @param props - Props including the banner content
 * @returns The rendered banner section component
 */
const SectionBanner = (props: SectionBannerProps) => {
  const { headerBannerCollection } = props;

  if (!headerBannerCollection?.items?.length) {
    return null;
  }

  return (
    <>
      {headerBannerCollection.items.map((banner, index) => {
        if (!banner.__typename) {
          return null;
        }

        switch (banner.__typename) {
          case 'FeaturedBanner':
            return <FeaturedBanner key={`banner-${index}`} {...(banner as FeaturedBannerProps)} />;
          case 'HeaderLogo':
            return <HeaderLogo key={`banner-${index}`} {...(banner as HeaderLogoProps)} />;
          default:
            console.warn(`SectionBanner: Unsupported banner type: ${banner.__typename}`);
            return null;
        }
      })}
    </>
  );
};

export default SectionBanner;
